import { JSX, useContext } from 'react';
import StyledHeader from '../../styles/StyledHeader';
import Avatar from '../Avatar/Avatar';
import Text from '../Text/Text';
import AppContext from '../../contexts/AppContext';
import AppContextType from '../../types/AppContextType';
import InfoMenu from '../InfoMenu/InfoMenu';

const Header = (): JSX.Element => {
  const { configuration } = useContext<AppContextType>(AppContext);

  if (!configuration) return <></>;

  return (
    <StyledHeader $backgroundColor={configuration.theme_color}>
      <div className='left-content'>
        <Avatar altText={configuration.company} url={configuration.header_avatar_url} height='47px' width='47px'/>
        <Text tag='h1' text={configuration.header_text} color='white' />
      </div>
      <InfoMenu />
    </StyledHeader>
  );
};

export default Header;
